module.exports = __webpack_public_path__ + "static/media/logoURI_192.0ae29e58.png";